import { useState,useEffect } from "react";
import { Card, Container, Input, FormButton, Text, Checkbox } from "../components/UI"
import { useForm, Controller } from "react-hook-form";
import { useUserData } from "../hooks/useUserData";
import PasswordStrengthBar from "react-password-strength-bar";
import { Classes } from "../theme/Classes";
import { useSearchParams } from "react-router-dom";
import { useController } from "../hooks/useController";
import { APP_SETTINGS } from "../hooks/useAppSettings";

export const ResetPasswordStep2 = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const email = searchParams.get("email");
    const securityStamp = searchParams.get("securitystamp");
    const { handleSubmit, control, formState: { errors }, getValues } = useForm({ mode: 'onChange' });
    const [message, setMessage] = useState('');
    const {postData: reset, data: resetData, response:resetResponse} = useController();
    const {lang} = useUserData();
    const onSubmit =  async data => {
        await reset( `${APP_SETTINGS.api}/Account/ResetPasswordStep2?password=${data.password}&email=${email}&securitystamp=${securityStamp}`, 'POST');
     
    }
    useEffect(()=>{
        if(resetResponse?.ok && resetResponse)
        {
          setMessage("Your password has been reset. You can now login")
        }
        else {
            if(resetResponse)
            setMessage("Error.")
        }
    },[resetData,resetResponse])
    return   (
        <Container>
            <Card>
                <Text role="h1">{lang?.changePassword}</Text>
                
                <Controller
                            name="password"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                    message: lang?.passwordDoesNotMatchCriteria
                                }
                            }}

                            render={({ field }) => <><Input props={field} placeholder="Password" type="password" />
                                <PasswordStrengthBar password={field.value} /></>}
                        />

                        {errors.password && errors.password.type === "required" && (
                            <Text role="validationMessage">{lang?.passwordRequired}.</Text>
                        )}
                        {errors.password && errors.password.type !== "required" && (
                            <Text role="validationMessage">{errors.password.message}</Text>
                        )}
                        <Text role="subtitle">{lang?.useAMinimum}</Text>
                    <Controller
                        name="confirmPassword"
                        control={control}
                        rules={{ required: true, validate: (value) =>
                            value === getValues("password") || lang?.passwordDontMatch
                        }}
                        render={({ field }) => <Input type="password" placeholder={lang?.confirmNewPassword} props={field} />}
                    />
                    {errors.confirmPassword && <Text role="validationMessage" >{errors.confirmPassword?.message}</Text>}
                    <button style={{...Classes.Button.Secondary}} title="Log In" onClick={handleSubmit(onSubmit)}>
                        {lang?.edit}
                    </button>
                    
                    <p style={{color:'white'}}>{message != '' && message}</p>
            </Card>
        </Container>
    )
}